import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Card Component
 * Container component with optional header and footer
 */
import { forwardRef } from 'react';
import { cn } from '../utils/cn.js';
const paddingStyles = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
};
export const Card = forwardRef(({ className, header, footer, padding = 'md', hoverable = false, bordered = false, children, ...props }, ref) => {
    return (_jsxs("div", { ref: ref, className: cn('bg-white/60 backdrop-blur-sm rounded-2xl shadow-sm shadow-gray-900/5 dark:bg-slate-900/60 dark:shadow-slate-950/20', bordered && 'border border-gray-200 dark:border-slate-700', hoverable && 'transition-shadow hover:shadow-md cursor-pointer', className), ...props, children: [header && (_jsx("div", { className: "px-6 py-4 border-b border-gray-100/50 dark:border-slate-800/50", children: typeof header === 'string' ? (_jsx("h3", { className: "text-lg font-semibold text-gray-900 dark:text-slate-100", children: header })) : (header) })), _jsx("div", { className: paddingStyles[padding], children: children }), footer && (_jsx("div", { className: "px-6 py-4 border-t border-gray-100/50 bg-gray-50/50 rounded-b-2xl dark:border-slate-800/50 dark:bg-slate-800/50", children: footer }))] }));
});
Card.displayName = 'Card';
//# sourceMappingURL=Card.js.map